<template>
  <div style="width: 100%; height: 100%;" :id="'calculatorPointsMap'+odp.id"></div>
</template>

<script>
  // var _ = require('lodash');

  // const axios = require('axios');
  // eslint-disable-next-line
  import loadYmaps from "../../helpers/ymaps-loader";

  // const ACCURATEWEB_API_URL = odpApiUrl;
  // // eslint-disable-next-line
  // const ACCURATEWEB_API_TOKEN = odpApiToken;

  // eslint-disable-next-line
  const imageActive = {
    iconLayout: 'default#image',
    iconImageHref: 	'data:image/svg+xml;base64,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',
    iconImageSize: [42, 56],
    iconImageOffset: [-21, -56],
  };

  // eslint-disable-next-line
  // var pointsClusterer;
  // var multiRoute = null;
  // eslint-disable-next-line
  let myMap;
  export default {
    props: {
      odp: Object
    },
    name: 'YmapsView',
    components: {},
    data() {
      return {
        map: null,
        localGeoArea: [],
        pointsGeoObjects: [],
        sourceObjects: [],
        focusODP: '',
        ymapsMultiRouteCoords: [],
        userPosition: [],
        selectedPoint: ''
      }
    },
    methods: {
      createYMap () {
        loadYmaps().then(() => {
          let self = this;
          // eslint-disable-next-line
          ymaps.ready(() => {
            // eslint-disable-next-line
            myMap = new ymaps.Map('calculatorPointsMap' + self.odp.id, {
              controls: ['zoomControl'],
              center: [self.odp.geo.latitude, self.odp.geo.longitude],
              zoom: 18,
            }, {
              maxZoom: 18
            });
            // eslint-disable-next-line
            const searchStartPoint = new ymaps.control.SearchControl({
              options: {
                noPopup: false,
                placeholderContent: 'Введите ваш адрес'
              }
            });
            myMap.controls.add(searchStartPoint, {
              float: 'left',
              floatIndex: 1
            });
            // eslint-disable-next-line
            const point = new ymaps.GeoObject({
              geometry: {
                type: 'Point',
                coordinates: [self.odp.geo.latitude, self.odp.geo.longitude]
              },
            }, imageActive);
            point.odp = self.odp.id;
            myMap.geoObjects.add(point);
          });
        })
      }
    },
    mounted: function () {
      this.createYMap();
    }
  }
</script>

<style scoped>

</style>
